import { render, staticRenderFns } from "./ProfileNavigationBtn.vue?vue&type=template&id=62a7e0a1&scoped=true"
import script from "./ProfileNavigationBtn.vue?vue&type=script&lang=js"
export * from "./ProfileNavigationBtn.vue?vue&type=script&lang=js"
import style0 from "./ProfileNavigationBtn.vue?vue&type=style&index=0&id=62a7e0a1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a7e0a1",
  null
  
)

export default component.exports